import React from "react";
import { getCookie } from "../jwt/_helpers/cookie";
import AsyncDropdownNormal from "./asyncDropdownNormal";

const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const ReleaseSubUserFilter = ({ subUserData, selectStyles }) => {
  const token = getCookie("token");

  const selectedSubUser = subUserData.subUser
    ? (() => {
        const match = String(subUserData.subUserEndpoint || "").match(/sub-user\/(\d+)\//);
        return {
          label: subUserData.subUser,
          value: match ? String(match[1]) : "",
        };
      })()
    : null;

  return (
    <div className="release-toolbar-subuser">
      <div className="release-toolbar-select-inner">
        <AsyncDropdownNormal
          endpoint="sub-users"
          subUserEndpoint=""
          parentUserOnly=""
          queryParams="&page=1&page_size=10"
          labelField="friendly_name"
          valueField="id"
          placeholder="Select Sub-User"
          fetchOptions={{
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "x-api-key": X_API_KEY,
              "Content-Type": "application/json",
            },
          }}
          value={selectedSubUser}
          onChange={(subUserObj) => {
            if (!subUserObj || subUserObj.value === "") {
              subUserData.setSubUser("");
              subUserData.setSubUserEndpoint("");
              subUserData.setParentUserOnly("");
              return;
            }

            subUserData.setSubUser(subUserObj.label);
            subUserData.setSubUserEndpoint(`sub-user/${String(subUserObj.value)}/`);
            subUserData.setParentUserOnly("");
          }}
          className="release-toolbar-subuser-select"
          classNamePrefix="release-filter"
          components={{ IndicatorSeparator: () => null }}
          styles={selectStyles}
        />
      </div>
    </div>
  );
};

export default ReleaseSubUserFilter;
